<template lang='pug'>
  .article-card(:class='extraMargin ? "mb" : null')
    router-link(:to='articlePath' @click.native='scrollToTop')
      .article-image(:class='imageClasses')
        img(:src='mainImage', :alt='mainImageAltText')
      .article-detail(:class='leftAlign ? "text-left" : null')
        b.filter-name(v-text='capitalized(contentType.name)')
        h2.title(:class='titleClasses' v-text='title')
        p.text-snippet(v-text='textSnippet')
        p.dim(v-text='publishedSince')
</template>

<script>
import { dateUtil } from '../../../mixins/dateUtil'
export default {
  mixins: [dateUtil],
  props: {
    id: { type: String, default: '' },
    title: { type: String, default: '' },
    textSnippet: { type: String, default: '' },
    contentType: { type: Object, default: Object.new },
    mainImage: { type: String, default: '' },
    publishedAt: { type: Date, default: new Date() },
    slugUrl: { type: String, default: '' },
    extraMargin: { type: Boolean, default: false },
    leftAlign: { type: Boolean, default: false },
    isMain: { type: Boolean, default: false },
    isNextArticle: { type: Boolean, default: false },
    mainImageAltText: { type: String, default: '' }
  },
  computed: {
    capitalized () {
      return (text) => text.toUpperCase()
    },
    imageClasses () {
      const classes = []

      if (this.isMain) {
        classes.push('main')
      }

      if (this.isNextArticle) {
        classes.push('next-article')
      }

      if (classes.length === 0) {
        return null
      } else {
        return classes.join(' ')
      }
    },
    titleClasses () {
      const classes = []

      if (this.isNextArticle) {
        classes.push('next-article')
      }

      if (classes.length === 0) {
        return null
      } else {
        return classes.join(' ')
      }
    },
    articlePath () {
      return { name: 'beautyfeed-show', params: { slug: this.slugUrl } }
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang='scss' scoped>
  * {
    box-sizing: border-box;
  }

  .article-card {
    cursor: pointer;
    margin-bottom: 30px;

    &.mb {
      margin-top: -10px;
    }
  }

  .article-image {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    margin: auto;
    margin-bottom: 20px;

    width: 100%;
    height: 281px;

    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    @include media-breakpoint-up(md) {
      height: 408px;
    }

    @include media-breakpoint-up(lg) {
      &.main {
        height: 554px;
      }
    }

    &.next-article {
      height: 194px;
    }

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .article-detail {
    padding: 0 15px;

    .title {
      width: 100%;
      font-size: 24px;
      line-height: 29px;

      margin-bottom: 8px;

      &.next-article {
        font-size: 16px;
        line-height: 18px;
      }
    }

    .filter-name {
      width: 100%;

      display: block;
      font-size: 13px;
      font-weight: bold;
      color: #C9362F;

      margin-bottom: 6px;
    }

    .text-snippet {
      word-wrap: break-word;
      font-size: 14px;
      line-height: 18px;
      color: #666666;
    }

    .dim {
      margin-top: 8px;
      color: #999999;
    }

    &.text-left {
      text-align: left;
    }

    @include media-breakpoint-up(md) {
      padding: 0;
      text-align: center;
    }
  }
</style>
